




























import { Component, Vue } from 'vue-property-decorator'
import vuescroll, { Config } from 'vuescroll'
import SongRequestDisplayer from '@/components/party/queue/SongRequestDisplayer.vue'
import { Getter } from 'vuex-class'
import SongRequest from '@/types/SongRequest'

const namespace = 'partyRoom'

@Component({
  components: {
    SongRequestDisplayer,
    vuescroll
  }
})
export default class QueueDisplayer extends Vue {
  @Getter('queue', { namespace }) queue!: Array<SongRequest>

  get playingPlayingplaylist () {
    return this.$store.state.partyRoom.playingPlaylist
  }

  get queueSliced () {
    return this.queue.slice(this.$store.state.partyRoom.partyRoom.playingPlaylist ? 0 : 1)
  }

  ops: Config = {
    scrollPanel: {
      scrollingX: false
    },
    rail: {
      opacity: 1,
      size: '0px'
    },
    bar: {
      disable: true
    }
  }

  created () {
    const vs = this.$refs.vs as vuescroll
  }
}
